import { render } from "./CropSizeWeekly.vue?vue&type=template&id=6ea2c264"
import script from "./CropSizeWeekly.vue?vue&type=script&lang=js"
export * from "./CropSizeWeekly.vue?vue&type=script&lang=js"

import exportComponent from "/home/noe/Dev/atc/agrotecchain_vue/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__